// SETTINGS V2 atom — SSelectField. The shared-wrapper adapter and the ONLY
// sanctioned <select> path in settings/v2 (SETTINGS_V2_SP4 §4). Composes SField
// chrome around the shared FormSelect (shared/components/redesign/forms) —
// NEVER a native <select>, NEVER raw MUI authored here (MUI *inside* the shared
// wrapper is sanctioned per SHARED_DEPLOY_AND_RULES canonical decision 1/3).
//
// FormSelect is asked for `visual="cssVars"` (defers to the scoped tokens) and
// given a `dropdownClassName` carrying the v2 scope classes — MUI portals the
// menu to document.body OUTSIDE `.settings-v2-root`, so without the classes the
// CSS vars would not resolve in the open dropdown (same trap SP3 solved for the
// Radix portal). No `sx`/dt authored here (both grep-banned in v2).
import React from "react";
import { useAppSelector } from "../../../../shared/hooks/sharedHooks";
import FormSelect from "../../../../shared/components/redesign/forms/FormSelect";
import type { FormSelectOption } from "../../../../shared/components/redesign/forms/FormSelect";
import SField from "./SField";

export interface SSelectFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  value: string | number;
  onChange: (v: string | number) => void;
  options: FormSelectOption[];
  placeholder?: string;
  /** Disabled state (SP7 — pass-through to FormSelect; e.g. the locked EUR
   *  currency select on the Pricing page). */
  disabled?: boolean;
}

const SSelectField: React.FC<SSelectFieldProps> = ({
  label,
  required,
  error,
  value,
  onChange,
  options,
  placeholder,
  disabled,
}) => {
  const theme = useAppSelector((s) => s.settingsV2Ui.theme);
  return (
    <SField label={label} required={required} error={error}>
      <FormSelect
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        error={!!error}
        fullWidth
        visual="cssVars"
        disabled={disabled}
        dropdownClassName={`settings-v2-root p-${theme} mod-nastavenia`}
      />
    </SField>
  );
};

export default SSelectField;
